import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { enableNotifications } from 'actions/enableNotification';
import { socket } from 'helpers/socket';
import { PROFILE } from 'endpointsConst';

const initialState = {
  profileData: {},
  error: null,
};

export const getProfile = createAsyncThunk('profile/get', async (data, { rejectWithValue, dispatch }) => {
  try {
    const res = await axios.get(PROFILE);
    const userId = res.data.id;

    // Подключаемся к Socket.IO, но не прерываем процесс, если подключение не удалось
    try {
      await socket.connect(userId);
      dispatch(enableNotifications());
    } catch (socketError) {
      console.warn('Socket.IO connection failed, but continuing:', socketError);
      // Не прерываем процесс авторизации из-за ошибки Socket.IO
      // Socket.IO может переподключиться позже
    }

    return res.data;
  } catch (error) {
    // Только ошибки API должны вызывать reject
    return rejectWithValue(error.response?.status || 500);
  }
});

export const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    removeProfileData: (state) => {
      state.profileData = {};
      state.error = null;
    },
  },
  extraReducers: {
    [getProfile.fulfilled]: (state, action) => {
      state.profileData = action.payload;
    },
    [getProfile.rejected]: (_state, _action) => {
      // TODO errors
    },
  },
});

export const { removeProfileData } = profileSlice.actions;

export default profileSlice.reducer;
